// Vorlesen für Kinder, die noch nicht lesen können (readAloud.nl.ts). Deutsche Fassung.
export const readAloudDe = {
    button: 'Vorlesen',
    stop: 'Vorlesen beenden',
    task: '{task} vorlesen',
};
//# sourceMappingURL=readAloud.de.js.map